import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(duration);
dayjs.extend(customParseFormat);

export function diffInMinutes(startTime, endTime) {
  const start = dayjs(startTime, 'HH:mm');
  const end = dayjs(endTime, 'HH:mm');

  let diff = end.diff(start, 'minute');
  if (diff < 0) diff += 24 * 60;

  return diff;
}

export function formatMinutesToHHmm(totalMinutes) {
  const hours = Math.floor(totalMinutes / 60).toString().padStart(2, '0');
  const minutes = (totalMinutes % 60).toString().padStart(2, '0');
  return `${hours}:${minutes}`;
}

export function timeToMinutes(timeStr) {
  const time = dayjs(timeStr, 'HH:mm', true);

  if (!time.isValid()) {
    return null;
  }

  return (time.hour() * 60) + time.minute();
}

export function calculateTotalTime(initial, final, intervalStart, intervalEnd) {
  const isValid = t => /^\d{2}:\d{2}$/.test(t);

  const validInitial = isValid(initial);
  const validFinal = isValid(final);
  const validIntervalStart = isValid(intervalStart);
  const validIntervalEnd = isValid(intervalEnd);

  if (!validInitial || !validFinal) return 0;

  const total = diffInMinutes(initial, final);
  const interval = (validIntervalStart && validIntervalEnd)
    ? diffInMinutes(intervalStart, intervalEnd)
    : 0;

  return total - interval;
}

